import { motion } from "framer-motion";
import { LEVEL_STYLES } from "@/components/CreatorLevelBadge";

/** Gemma cinematografica: rotazione 3D + aura conica + fumo colorato drifting. */
export const GemCinematic = ({ level = 1, size = 150, mode = "sway", delay = 0, className = "" }) => {
  const s = LEVEL_STYLES[level] || LEVEL_STYLES[1];
  const anim = mode === "spin"
    ? { rotateY: [0, 360], y: [0, -8, 0] }
    : { rotateY: [-16, 16, -16], y: [0, -7, 0] };
  const trans = mode === "spin"
    ? {
        rotateY: { duration: 7, repeat: Infinity, ease: "linear", delay },
        y: { duration: 3.8, repeat: Infinity, ease: "easeInOut" },
      }
    : {
        rotateY: { duration: 6.5, repeat: Infinity, ease: "easeInOut", delay },
        y: { duration: 4.2, repeat: Infinity, ease: "easeInOut" },
      };
  return (
    <span className={`gfx ${className}`} style={{ width: size, height: size, "--gfx-ring": s.ring }}>
      <span className="gfx-aura" />
      <span className="gfx-smoke" />
      <span className="gfx-smoke2" />
      <motion.img
        src={s.img}
        alt={s.name}
        draggable="false"
        animate={anim}
        transition={trans}
        style={{ filter: `drop-shadow(0 0 ${typeof size === "number" ? Math.round(size / 4) : 44}px ${s.ring}b3)` }}
      />
      <span className="gfx-shine" />
    </span>
  );
};

export default GemCinematic;
